import { useMemo } from 'react';

export const CheckHistoryTypes = {
  CompletedCheck: 1,
  CompletedReferee: 2,
  CompletedRefereeIpError: 3,
  CompletedCandidate: 4,
  UpdatedEmail: 5,
  UpdatedContactNumber: 6,
  UpdatedDepartment: 7,
  UpdatedJobRole: 8,
  RequestSentCandidate: 9,
  RequestOverdueCandidate: 10,
  RequestSentReferee: 11,
  RequestOverdueReferee: 12,
  NewReferee: 13,
  NewCheck: 14,
  BackgroundCheckSubmitted: 15,
  BackgroundCheckProcessing: 16,
  BackgroundCheckCompleted: 17,
  BackgroundCheckRejected: 18,
  BackgroundCheckUpdated: 19,
  CandidateEmailFailed: 20,
  RefereeEmailFailed: 21,
  CheckCanceled: 22,
  CandidateEmailOpened: 23,
  RefereeEmailOpened: 24,
  CandidateEmailClicked: 25,
  RefereeEmailClicked: 26,
  CustomNote: 27,
  CustomInfo: 28,
  CustomSuccess: 29,
  CustomWarning: 30,
  CustomError: 31,
  CheckDeclined: 32,
  CheckAddNotes: 33,
  CheckUpdateStatus: 34,
  RefereeDeleted: 35,
  SubCheckCompleted: 36,
  CandidateSMSOpened: 37,
  RefereeSMSOpened: 38,
  RefereeReplacement: 39,
  ReminderCandidate: 40,
  ReminderReferee: 41,
  UpdatedCandidateTeam: 42,
  CheckResult: 43,
  TransferCandidateAssignment: 44,
  NewCandidateAssignment: 45,
  CheckUndoCompletion: 46,
  NewReferencePlusForm: 47,
  NewReferencePlusCommonForm: 48,
  NewReferenceForm: 49,
  UserCompletedRefereeForm: 50,
  BundleCheckAdded: 51,
  UpdatedCandidateArchived: 52,
  RefereeRequestSent: 53,
  CandidateEmailDelivered: 54,
  RefereeEmailDelivered: 55,
  CandidateRefereeBackupRequest: 56,
  SubCheckUpdateStatus: 57,
  ExternalBotMessage: 58,
  CandidateDocumentRequestSent: 59,
  CandidateDocumentUploaded: 60,
  CheckBlocked: 61,
  SubCheckCanceled: 62,
  CandidatePortalInvitationSent: 63,
  CandidateCanceledCheck: 64,
  CandidateCheckResultView: 65,
  UpdatedCandidateHiringStatus: 66,

  // Internal use only
  AdminGeneral: 1000,
  AdminFollowUpProvider: 1001,
  AdminFollowUpCandidate: 1002,
  AdminFollowUpClient: 1004,
  AdminFeedback: 1005,
};

export const AdminHistoryTypes = {
  1000: { color: 'neutral', title: 'General' },
  1001: { color: 'continue', title: 'Follow up provider' },
  1002: { color: 'warning', title: 'Follow up candidate' },
  1004: { color: 'warning', title: 'Follow up client' },
  1005: { color: 'neutral', title: 'Feedback' },
};

export const AdminHistoryTypesList = Object.keys(AdminHistoryTypes).map(key => ({
  value: key,
  name: AdminHistoryTypes[key].title,
}));
